import React, { useCallback, useState } from "react";
import styled from "styled-components";
import AppConfig from "util/AppConfig";
import Icon from "components/common/Icon";
import Button from "components/bootstrap/Button";
import ErrorPage from "components/errors/ErrorPage";
import SupportSources from "components/support/SupportSources";
import ClipboardButton from "components/common/ClipboardButton";
import useProductName, { DEFAULT_PRODUCT_NAME } from "brand-customization/useProductName";
const ToggleDetails = styled.div`
  font-weight: normal;
`;
const description = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "It seems like the page you navigated to contained an error."), /* @__PURE__ */ React.createElement("p", null, "You can use the navigation to reach other parts of the product, refresh the page or submit an error report."));
const RuntimeErrorPage = ({ error, componentStack }) => {
  const [showDetails, setShowDetails] = useState(AppConfig.gl2DevMode());
  const errorDetails = `

Stack Trace:

${error.stack}

Component Stack:
${componentStack}`;
  const productName = useProductName();
  const isDefaultProduct = productName === DEFAULT_PRODUCT_NAME;
  const _toggleDetails = useCallback((e) => {
    e.preventDefault();
    setShowDetails((cur) => !cur);
  }, []);
  return /* @__PURE__ */ React.createElement(ErrorPage, { title: "Something went wrong.", description }, isDefaultProduct && /* @__PURE__ */ React.createElement("div", { className: "content", style: { padding: "2em" } }, /* @__PURE__ */ React.createElement(SupportSources, null)), /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, "Error:", /* @__PURE__ */ React.createElement(ToggleDetails, { className: "pull-right" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "link", tabIndex: 0, onClick: _toggleDetails }, showDetails ? "Show less" : "Show more"))), /* @__PURE__ */ React.createElement("dt", null, /* @__PURE__ */ React.createElement("pre", { className: "content", id: "render-error" }, /* @__PURE__ */ React.createElement("div", { className: "pull-right" }, /* @__PURE__ */ React.createElement(
    ClipboardButton,
    {
      title: /* @__PURE__ */ React.createElement(Icon, { name: "content_copy" }),
      bsSize: "sm",
      text: `${error.message}
${errorDetails}`,
      buttonTitle: "Copy error details to clipboard"
    }
  )), error.message, showDetails && errorDetails))));
};
export default RuntimeErrorPage;
